
import Vue from 'vue'
import { AppModule } from '@/store/module'
import ContactForm from '@/components/global/ContactForm.vue'

export default Vue.extend({
  components: {
    ContactForm,
  },
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isH5() {
      return AppModule.isH5
    },
  },
})
